import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { mergeInitialValues } from '@utils/formik';
import { useFormValues } from '@components/HealthQuoteBuyRoute/HealthQuoteBuyCustomForm';

import { selectCancerQuoteBuyRoute } from '../selector';

export const useInitialValues = () => {
  const { cancerQuote } = useSelector(selectCancerQuoteBuyRoute);
  const values = useFormValues();

  return useMemo(() => {
    if (!cancerQuote) return null;
    const { members } = cancerQuote;
    return mergeInitialValues(values, { ...cancerQuote, ...members });
  }, [cancerQuote]);
};
